export default "__VITE_ASSET__Cq$LqztT__"